import React, { Fragment } from 'react';
import Modal from 'react-modal';
import Input from '../../../TravellerContactInfo/FormFields/Input';
import '../../LoginModals.css';
import { useEmailAndMobileNotVerifiedContainer } from '../EmailAndMobileNotVerifiedContainer';
import { customStyles, UserFlowModalState } from '../../../UserFlow/UserFlowModal';

const MobileNotVerified = (props: UserFlowModalState) => {

  const {
    props: {
      showModal,
      state,
      userStatus,
      errorMessage,
    },

    action: {
      rotateLoader,
      closeModal,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
      handleInputKeyUpViaParentMobile,
    },
  } = useEmailAndMobileNotVerifiedContainer(props);

  const { userId } = userStatus;

  const {
    validationFail,
    disabledByMobile,
    rotate,
    resendOtpEnabled
  } = state;

  return (
    <Fragment>
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        onRequestClose={closeModal}
        className={`loginModals loginModals--v2 loginModals--exWidth`}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            backgroundColor: 'rgb(0, 0, 0, 0.6)',
            zIndex: 1,
          },
          customStyles,
        }}
      >
        <p className={'makeFlex spaceBetween appendBottom10'}>
          <span className={'modalTitle font26 latoBlack blackText appendBottom20'}>
              Enter IRCTC Username
          </span>
          <span
            className="modalClose railSprite crossIcon"
            onClick={closeModal}>
          </span>
        </p>
        <p className={'additionalInfo  font14'} style={{ padding: 10 }}>
            IRCTC username <span className="blackText">will be required after Payment</span>. Please ensure you have entered correct username.
        </p>
        <div className={'makeFlex column spaceBetween'}>
          <div className='appendTop20'>
            <Input
              labelName="Enter IRCTC Username"
              validationFail={false}
              type="text"
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg={null}
              vaidationMoreStatus={false}
              vaidationStatus={true}
              readOnly={true}
              value={userId}
            />
          </div>
          <p className={'blackText font14 appendTop30'}>Your mobile is not verified. Please enter the OTP sent to your registered mobile.</p>
          <div className='makeFlex end row'>
            <div className="appendTop30 column">
              <Input
                errorMessage="Please enter OTP."
                validationFail={false}
                type="text"
                additionalAttributes={{ placeholder: 'Enter Mobile OTP' }}
                fieldId="IRCTCUserName"
                fieldName="IRCTCUserName"
                vaidationMsg=""
                vaidationMoreMsg={null}
                vaidationMoreStatus={false}
                vaidationStatus
                readOnly={false}
                handleInputKeyUpViaParent={handleInputKeyUpViaParentMobile}
              />
              {errorMessage !== null && <span className="font12 redText"> {errorMessage}</span>}
            </div>
            <div className={'column'}>
              <button
                onClick={rotateLoader}
                className={`${disabledByMobile ? 'disabled' : ''} noShrink ${errorMessage ? 'appendBottom20' : 'appendBottom5'} appendLeft20`}>
                <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack capText'}`}>
                Submit
                </span>
              </button>
            </div>
          </div>
        </div>
        <p className='hrtlSeperater'></p>
        <div className='makeFlex column spaceBetween'>
          <p className='appendBottom20'><a className='font16 latoBold ' onClick={goToForgotUsernamePage}>Forgot Username</a></p>
          <p className='appendBottom20'><a className='font16 latoBold ' onClick={goToIRCTCRegistrationPage}>Create New Account</a></p>
        </div>
      </Modal>
    </Fragment>
  );
};

export default MobileNotVerified;
